export const routes = [
  {
    path: '/dev',
    /* internal name: '/dev' */
    /* no component */
    children: [
      {
        path: '',
        name: '/dev/',
        component: () => import('/app/src/pages/dev/index.vue'),
        /* no children */
      },
      {
        path: 'xml-mapper-test',
        /* internal name: '/dev/xml-mapper-test' */
        /* no component */
        children: [
          {
            path: '',
            name: '/dev/xml-mapper-test/',
            component: () => import('/app/src/pages/dev/xml-mapper-test/index.vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/Home',
    name: '/Home',
    component: () => import('/app/src/pages/Home.vue'),
    /* no children */
  },
  {
    path: '/Index',
    name: '/Index',
    component: () => import('/app/src/pages/Index.vue'),
    /* no children */
  },
  {
    path: '/multiple-resolution',
    /* internal name: '/multiple-resolution' */
    /* no component */
    children: [
      {
        path: '',
        name: '/multiple-resolution/',
        component: () => import('/app/src/pages/multiple-resolution/index.vue'),
        /* no children */
        meta: {
          "requiresCDSAuth": true,
          "icon": "mdi-directions-fork"
        }
      },
      {
        path: 'register-urls',
        name: '/multiple-resolution/register-urls',
        component: () => import('/app/src/pages/multiple-resolution/register-urls.vue'),
        /* no children */
        meta: {
          "requiresCDSAuth": true,
          "hideNavMenuEntry": true
        }
      },
      {
        path: 'unlock',
        name: '/multiple-resolution/unlock',
        component: () => import('/app/src/pages/multiple-resolution/unlock.vue'),
        /* no children */
        meta: {
          "requiresCDSAuth": true,
          "hideNavMenuEntry": true
        }
      }
    ],
  },
  {
    path: '/NotAuthorised',
    name: '/NotAuthorised',
    component: () => import('/app/src/pages/NotAuthorised.vue'),
    /* no children */
  },
  {
    path: '/PageNotFound',
    name: '/PageNotFound',
    component: () => import('/app/src/pages/PageNotFound.vue'),
    /* no children */
  },
  {
    path: '/records',
    /* internal name: '/records' */
    /* no component */
    children: [
      {
        path: '',
        name: '/records/',
        component: () => import('/app/src/pages/records/index.vue'),
        /* no children */
        meta: {
          "breadcrumb": "record-registration-title"
        }
      },
      {
        path: ':id/:stepname?',
        name: '/records/[id].[[stepname]]',
        component: () => import('/app/src/pages/records/[id].[[stepname]].vue'),
        /* no children */
      },
      {
        path: ':id/complete',
        name: '/records/[id].complete',
        component: () => import('/app/src/pages/records/[id].complete.vue'),
        /* no children */
      },
      {
        path: 'edit',
        /* internal name: '/records/edit' */
        /* no component */
        children: [
          {
            path: '',
            name: '/records/edit/',
            component: () => import('/app/src/pages/records/edit/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'new',
        /* internal name: '/records/new' */
        /* no component */
        children: [
          {
            path: 'doi',
            name: '/records/new/doi',
            component: () => import('/app/src/pages/records/new/doi.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'new/:recordType?',
        name: '/records/new.[[recordType]]',
        component: () => import('/app/src/pages/records/new.[[recordType]].vue'),
        /* no children */
        meta: {
          "breadcrumb": "records-register-journal-article"
        }
      }
    ],
  }
]

export function handleHotUpdate(_router) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    router.replace('')
  })
}

